import restaurantCard from "./RestaurantCard";
import { useState } from "react";
import { useEffect } from "react";
import Shimmer from "./Shimmer";
// import { Link } from "react-router-dom";
import filterData from "../utils/helper";
import  { withPromtedLabel } from "./RestaurantCard";
import { RestaurantList } from "../constants";
import useOnline from "../utils/useOnline";

const Body = () => {

     // let searchTxt ="kfc";
     const [searchTxt, setsearchTxt] = useState(""); // creating a state variable in react
     const [allrestaurants, setallrestraurants] = useState([]);
     const [filteredrestaurants, setfilteredrestaurants] = useState([]);
     useEffect(() => {
          fetchData();
     }, []);

     // console.log("render");

     const fetchData = async () => {
          // const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.6126255&lng=77.04108959999999&page_type=DESKTOP_WEB_LISTING");

          const data = RestaurantList;
          setallrestraurants(data);
          setfilteredrestaurants(data);

          // const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=26.76310&lng=83.37290&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
          // const json = await data.json();
          // console.log(json);
          // setallrestraurants(json.data?.cards[2]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
          // setfilteredrestaurants(json.data?.cards[2]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
     }

     const RestaurantPromotedCard = withPromtedLabel(restaurantCard);

     const isOnline = useOnline();
     if (!isOnline) {
          return <h1 className="justify-center">YOU ARE OFFLINE, PLEASE CHECK YOUR CONNECTION</h1>
     }

     if (!allrestaurants) return null;   // not render component (early return)

     // if(filteredrestaurants?.length === 0)
     //  return <h1>No restaurant available</h1>

     return (allrestaurants?.length === 0) ? <Shimmer /> : (
          <>
               <div
                    // className="search-container"
                    className="search m-4 p-4"
               >
                    <input type="text"
                         // className="search-input" 
                         className="border border-solid border-black p-2"
                         placeholder="Search"
                         value={searchTxt}
                         onChange={(e) => {
                              setsearchTxt(e.target.value);
                         }}
                    />

                    <button
                         // className="search-btn"
                         className="px-4 py-2 bg-green-300 m-4 rounded-xl"
                         onClick={() => {

                              const data = filterData(searchTxt, allrestaurants);
                              setfilteredrestaurants(data);

                         }}> Search</button>
               </div>

               <div
                    // className="restaurant-list"
                    className="flex flex-wrap bg-orange-50 justify-center "
               >
                    {
                         filteredrestaurants.map((restaurant) => {
                              return (

                                   (restaurant.info.promoted === true) ? restaurantCard(restaurant) : RestaurantPromotedCard(restaurant)
                              )
                         })}
               </div>
          </>
     );
};
export default Body;